module.exports = __webpack_public_path__ + "img/horangit_face.dd4811ab.png";